import React, { useEffect, useState } from "react";
import { CardContainer } from "../../../components/Card/CardContainer";
import { Card, Col, Divider, Form, Row, Tabs } from "antd";
import Text from "../../../components/Text/Text";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { icon } from "../../../resource";
import { FlexCol } from "../../../components/Container/Container";
import { CampaignTab } from "./TabDetail/Campaign";
import { ShopPointTab } from "./TabDetail/ShopPoint";
import { HistoryPointTab } from "./TabDetail/HistoryPoint";
import { CouponTab } from "./TabDetail/Coupon";
import { DealerReportTab } from "./TabDetail/DealerReport";

export const IndexOverviewPoint: React.FC = () => {
  const { companyType } = JSON.parse(localStorage.getItem("company")!);

  const RenderSectionSearch = () => {
    return (
      <CardContainer>
        <Row justify='space-between' align='middle'>
          <Col>
            <Text fontSize={20} fontWeight={700}>
              ภาพรวมแต้ม/คูปอง
            </Text>
          </Col>
          <Col>
            <Text color='Text3'>อัปเดตล่าสุด 12 พ.ย. 2569 • 11:30 น.</Text>
          </Col>
        </Row>
        <Divider size='small' />
        <Row justify='space-between' gutter={16}>
          <Col span={8}>
            <Form.Item label='รูปแบบการให้แต้มกับร้าน'>
              <Select
                data={[
                  { label: "Option 1", value: "1", key: "1" },
                  { label: "Option 2", value: "2", key: "2" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='เงื่อนไขการได้รับแต้ม'>
              <Select
                data={[
                  { label: "Option 1", value: "1", key: "1" },
                  { label: "Option 2", value: "2", key: "2" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label='รูปแบบการดูแคมเปญ'>
              <Select
                data={[
                  { label: "Option 1", value: "1", key: "1" },
                  { label: "Option 2", value: "2", key: "2" },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
      </CardContainer>
    );
  };

  const RenderSectionSummary = () => {
    const info = [
      { label: "แคมเปญ", value: "4", key: "1", icon: icon.magaphone_icon, hidden: false },
      { label: "ร้าน Dealer", value: "50", key: "2", icon: icon.pink_shop_icon, hidden: false },
      {
        label: "ร้าน Sub-Dealer",
        value: "370",
        key: "3",
        icon: icon.yellow_shop_icon,
        hidden: companyType === "Chemical",
      },
    ];
    return (
      <CardContainer>
        <Row justify='space-between' gutter={16}>
          {info.map((item) => {
            if (item.hidden) return null;
            return (
              <Col span={24 / info.filter((i) => !i.hidden).length} key={item.key}>
                <Card bodyStyle={{ padding: "16px" }}>
                  <Row justify='space-between'>
                    <FlexCol>
                      <Text>{item.label}</Text>
                      <Text level={2} fontWeight={700}>
                        {item.value}
                      </Text>
                    </FlexCol>
                    <FlexCol>
                      <img
                        src={item.icon}
                        alt={item.label}
                        style={{ width: "50px", height: "50px" }}
                      />
                    </FlexCol>
                  </Row>
                </Card>
              </Col>
            );
          })}
        </Row>
      </CardContainer>
    );
  };

  const itemTab = [
    { label: "แคมเปญ", key: "campaign", children: <CampaignTab />, hidden: false },
    { label: "แต้มร้านค้า", key: "shopPoint", children: <ShopPointTab data={[]} />, hidden: false },
    {
      label: "ประวัติแต้ม",
      key: "historyPoint",
      children: <HistoryPointTab data={[]} />,
      hidden: false,
    },
    {
      label: "คูปอง",
      key: "coupon",
      children: <CouponTab />,
      hidden: companyType === "Chemical",
    },
    {
      label: "รายงานเบิกชดเชย Dealer",
      key: "dealerReport",
      children: <DealerReportTab />,
      hidden: companyType === "Chemical",
    },
  ];

  return (
    <>
      <RenderSectionSearch />
      <br />
      <RenderSectionSummary />
      <br />
      <CardContainer>
        <Tabs
          style={{ fontFamily: "IBM Plex Sans Thai" }}
          items={itemTab.filter((item) => !item.hidden)}
        />
      </CardContainer>
    </>
  );
};

export const DashboardSummaryTab = ({ data }: { data?: any }) => {
  const { companyType } = JSON.parse(localStorage.getItem("company")!);

  const info =
    companyType === "Fertilizer"
      ? [
          {
            label: "ปริมาณรวม (ตัน)",
            value: "4,000.00",
            key: "1",
            icon: icon.box_point_icon,
            hidden: false,
          },
          {
            label: "แต้มรอบริษัทอนุมัติ",
            value: "50",
            key: "2",
            icon: icon.clock_point_icon,
            hidden: false,
          },
          {
            label: "แต้มที่ใช้ได้ (บริษัทอนุมัติแล้ว)",
            value: "370",
            key: "3",
            icon: icon.green_star_point_icon,
            hidden: false,
          },
          {
            label: "แต้มที่แลกแล้ว",
            value: "370",
            key: "3",
            icon: icon.arrow_point_icon,
            hidden: false,
          },
          {
            label: "แต้มหมดอายุ",
            value: "370",
            key: "3",
            icon: icon.gray_star_point_icon,
            hidden: false,
          },
        ]
      : [
          {
            label: "รอกดรับสินค้า",
            value: "50",
            key: "2",
            icon: icon.clock_point_icon,
            hidden: false,
          },
          {
            label: "แต้มที่ใช้ได้ (ยืนยันรับสินค้าแล้ว)",
            value: "370",
            key: "3",
            icon: icon.green_star_point_icon,
            hidden: false,
          },
        ];

  return (
    <Row justify='space-between' gutter={16}>
      {info.map((item, index) => {
        if (item.hidden) return null;
        return (
          <Col
            span={companyType === "Fertilizer" && index < 3 ? 8 : 12}
            key={item.key}
            style={{ marginBottom: "12px" }}
          >
            <Card bodyStyle={{ padding: "16px" }}>
              <Row justify='space-between' style={{ alignItems: "middle" }}>
                <FlexCol>
                  <Text level={6}>
                    <img
                      src={item.icon}
                      alt={item.label}
                      style={{ width: "20px", height: "20px" }}
                    />
                    &nbsp;
                    {item.label}
                  </Text>
                  <Text level={2} fontWeight={700}>
                    {item.value}
                  </Text>
                </FlexCol>
              </Row>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};
